import { Typography, Box, Button, ToggleButton, ToggleButtonGroup, } from "@mui/material"
import { dateRangeFilterMethod } from "../utils/date-filter.js";
import { isFuzzyMatch, isExactMatch } from "../utils/index.js";
import { stringAToZInsensitive } from "@iamnapo/sort";
import DeleteIcon from '@mui/icons-material/Delete';

const TypographyCell = ({ value }) => (
    <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
        <Typography variant="body2">
            {value}
        </Typography>
    </Box>
);

const ArrayTextCell = ({ value }) => (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 1, alignItems: "flex-start" }}>
        {console.log("Times mesa sto header", value)}
        {value.map((item, index) => (
            <Typography variant="body2" key={index}>
                {item}
            </Typography>
        ))}
    </Box>
);

const ButtonCell = ({ value, onClick }) => (
    <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
        <Button
            variant="text"
            color="secondary"
            onClick={() => onClick(value)}
        >
            {value}
        </Button>
    </Box>
);

const DateCell = ({ value }) => (
    <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
        {value ? (
            <Typography variant="body2">
                {new Date(value).toLocaleDateString("el-GR")}
            </Typography>
        ) : null}
    </Box>
);

const DateButtonCell = ({ value, onClick }) => (
    <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
        <Button
            variant="text"
            color="secondary"
            onClick={() => onClick(value)}
        >
            {new Date(value).toLocaleDateString("el-GR")}
        </Button>
    </Box>
);

export const inspectorLastNameHeader = (handleLastNameClick) => {
    return {
        Header: <Typography id="lastname_header" variant="h8">{"Επώνυμο"}</Typography>,
        accessor: "lastName",
        id: "lastName",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleLastNameClick} />
        ),
    }
}

export const firstNameHeader = {
    Header: <Typography id="firstname_header" variant="h8">{"Όνομα"}</Typography>,
    accessor: "firstName",
    id: "firstName",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell
}

export const addressHeader = {
    Header: <Typography id="address_header" variant="h8">{"Διεύθυνση"}</Typography>,
    accessor: "address",
    id: "address",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const cityHeader = {
    Header: <Typography id="city_header" variant="h8">{"Πόλη"}</Typography>,
    accessor: "city",
    id: "city",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const countyHeader = {
    Header: <Typography id="county_header" variant="h8">{"Νομός"}</Typography>,
    accessor: "county",
    id: "county",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const postalCodeHeader = {
    Header: <Typography id="postalcode_header" variant="h8">{"Τ.Κ"}</Typography>,
    accessor: "postalCode",
    id: "postalCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const emailCodeHeader = {
    Header: <Typography id="email_header" variant="h8">{"E-mail"}</Typography>,
    accessor: "email",
    id: "email",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const phoneNumberHeader = {
    Header: <Typography id="phonenumber_header" variant="h8">{"Σταθερό"}</Typography>,
    accessor: "phoneNumber",
    id: "phoneNumber",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const cellPhoneHeader = {
    Header: <Typography id="cellphone_header" variant="h8">{"Κινητό"}</Typography>,
    accessor: "cellPhone",
    id: "cellPhone",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const createdAtHeader = {
    Header: <Typography id="createdAt_header" variant="h8">{"Ημ/νια εισόδου"}</Typography>,
    accessor: "createdAt",
    id: "createdAt",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const updatedAtHeader = {
    Header: <Typography id="flock_code_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Ημ/νία Τελευταίας Ενημέρωσης"}</Typography>,
    accessor: "updatedAt",
    id: "updatedAt",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: false,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const regDateHeader = {
    Header: <Typography id="reg_date_header" variant="h8">{"Ημ/νια Εγγραφής"}</Typography>,
    accessor: "registrationDate",
    id: "registrationDate",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}


export const organizationHeader = (organizations) => {
    return {
        Header: <Typography id="organization_header" variant="h8">{"Οργάνωση"}</Typography>,
        accessor: "organization",
        id: "organization",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
                <Typography
                    variant="body2"
                    sx={{
                        maxWidth: 180,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {organizations.find((organization) => organization._id === value)?.name}
                </Typography>
            </Box>
        ),
    }
}

export const userHeader = (users) => {
    return {
        Header: <Typography id="user_header" variant="h8">{"Χρήστης"}</Typography>,
        accessor: "user",
        id: "user",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
                <Typography variant="body2">
                    {users.find((user) => user._id === value)?.username}
                </Typography>
            </Box>
        ),
    }
}

export const codeHeader = (handleCodeClick) => {
    return {
        Header: <Typography id="code_header" variant="h8">{"Κωδικός στην εκτροφή"}</Typography>,
        accessor: "code",
        id: "code",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleCodeClick} />
        ),
    }
}

export const inspectorHeader = (inspectors) => {
    return {
        Header: <Typography id="inspector_header" variant="h8">{"Ελεγκτής"}</Typography>,
        accessor: "inspector",
        id: "inspector",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
                <Typography variant="body2">
                    {`${inspectors.find((inspector) => inspector._id === value)?.lastName || ""} ${inspectors.find((inspector) => inspector._id === value)?.firstName || ""}`}
                </Typography>
            </Box>
        ),
    }
}

export const metricHeader = (title, accessor) => {
    return {
        Header: <Typography id="metric_header" variant="h8">{title}</Typography>,
        accessor: accessor,
        id: accessor,
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: TypographyCell,
    }
}

export const fatherNameHeader = {
    Header: <Typography id="fathername_header" variant="h8">{"Όνομα Πατρός"}</Typography>,
    accessor: "fatherName",
    id: "fatherName",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const afmHeader = {
    Header: <Typography id="afm_header" variant="h8">{"Α.Φ.Μ"}</Typography>,
    accessor: "afm",
    id: "afm",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const outDateHeader = {
    Header: <Typography id="outdate_header" variant="h8">{"Ημ/νια εξόδου"}</Typography>,
    accessor: "outDate",
    id: "outDate",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const ownerLastNameHeader = {
    Header: <Typography id="lastname_header" variant="h8">{"Επώνυμο"}</Typography>,
    accessor: "lastName",
    id: "lastName",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: ({ value }) => (
        <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
            <Typography
                variant="body2"
                sx={{
                    maxWidth: 180,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}>
                {value}
            </Typography>
        </Box>
    ),
}

export const registrationCodeHeader = (handleAnimalCodeClick) => {
    return {
        Header: <Typography id="registration_code_header" variant="h8">{"Κωδ. Γενεαλογικού Βιβλίου"}</Typography>,
        accessor: "registrationCode",
        id: "registrationCode",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleAnimalCodeClick} />
        ),
    }
}

export const lambSlugCodeHeader = (handleLambSlugClick) => {
    return {
        Header: <Typography id="lamb_slug_header" variant="h8">{"Κωδικός Αμνού (τρέχων/παλαιός)"}</Typography>,
        accessor: "displayLambSlug",
        id: "displayLambSlug",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value, row }) => (
            <ButtonCell value={value} onClick={() => handleLambSlugClick(row._original)} />
        ),
    }
}

export const lambHistoricalCodeHeader = {
    Header: <Typography id="lamb_slug_header" variant="h8">{"Κωδικός Αμνού (τρέχων/παλαιός)"}</Typography>,
    accessor: "displayLambSlug",
    id: "displayLambSlug",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sexHeader = {
    Header: <Typography id="sex_header" variant="h8">{"Φύλο"}</Typography>,
    accessor: "sex",
    id: "sex",
    filterable: true,
    maxWidth: 150,
    minWidth: 150,
    useDropdownFilter: true,
    filterOptions: [
        { value: "Άρρεν", label: "Άρρεν" },
        { value: "Θήλυ", label: "Θήλυ" },
    ],
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => {
        return value.length === 0 || value.includes(row[id]);
    },
    Cell: TypographyCell,
}

export const birthDateHeader = {
    Header: <Typography id="birthDate_header" variant="h8">{"Ημ/νια γέννησης"}</Typography>,
    accessor: "birthDate",
    id: "birthDate",
    filterable: true,
    maxWidth: 250,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const birthDateHeaderNotFilterable = {
    Header: <Typography id="birthDate_header" variant="h8">{"Ημ/νια γέννησης"}</Typography>,
    accessor: "birthDate",
    id: "birthDate",
    filterable: false,
    maxWidth: 250,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const lambingDateHeaderNotFilterable = {
    Header: <Typography id="lambingDate_header" variant="h8">{"Ημ/νια τοκετού"}</Typography>,
    accessor: "lambingDate",
    id: "lambingDate",
    filterable: false,
    maxWidth: 250,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const mostRecentRecordingDateHeaderNotFilterable = {
    Header: <Typography id="mostRecentRecording_header" variant="h8">{"Ημ/νια Τελευταίου Ελέγχου"}</Typography>,
    accessor: "mostRecentRecordingDate",
    id: "mostRecentRecordingDate",
    filterable: false,
    maxWidth: 250,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const animalOwnerHeader = (handelOwnerClick, selectedOwner) => {
    return {
        Header: <Typography id="owner_header" variant="h8">{"Εκτροφή"}</Typography>,
        accessor: "owner",
        id: "owner",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
                <Button
                    variant="text"
                    color="secondary"
                    onClick={() => handelOwnerClick(value)}
                >
                    {`${selectedOwner?.lastName} ${selectedOwner?.firstName}`}
                </Button>
            </Box>
        ),
    }
}

export const flockCodeHeader = {
    Header: <Typography id="flock_code_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κωδικός στην εκτροφή"}</Typography>,
    accessor: "flockCode",
    id: "flockCode",
    filterable: false,
    maxWidth: 200,
    minWidth: 150,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const breedCodeHeader = {
    Header: <Typography id="breed_code_header" variant="h8">{"Φυλή"}</Typography>,
    accessor: "breedCode",
    id: "breedCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const recordingIncNumberHeaderNotFilterable = {
    Header: <Typography id="recIncNumber_header" variant="h8">{"Α/Α Τελευταίου Ελέγχου"}</Typography>,
    accessor: "lastNumber",
    id: "lastNumber",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sireCodeHeader = (handleAnimalCodeClick) => {
    return {
        Header: <Typography id="sire_code_header" variant="h8" sx={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflow: "hidden",
            textAlign: "center"
        }}>{"Κωδ. Γενεαλογικού Βιβλίου Πατέρα"}</Typography>,
        accessor: "sireCode",
        id: "sireCode",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleAnimalCodeClick} />
        ),
    }
}

export const damCodeHeader = (handleAnimalCodeClick) => {
    return {
        Header: <Typography id="dam_code_header" variant="h8" sx={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflow: "hidden",
            textAlign: "center"
        }}>{"Κωδ. Γενεαλογικού Βιβλίου Μητέρας"}</Typography>,
        accessor: "damCode",
        id: "damCode",
        filterable: false,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleAnimalCodeClick} />
        ),
    }
}

export const cullingCodeHeader = {
    Header: <Typography id="culling_code_header" variant="h8">{"Αιτία απομάκρυνσης"}</Typography>,
    accessor: "cullingCode",
    id: "cullingCode",
    filterable: true,
    useDropdownFilter: true,
    filterOptions: [
        { value: "Σφαγή", label: "Σφαγή" },
        { value: "Πώληση Αναπαραγ", label: "Πώληση Αναπαραγ" },
        { value: "Μεγάλη Ηλικία", label: "Μεγάλη Ηλικία" },
        { value: "Θάνατος", label: "Θάνατος" },
        { value: "Διάφοροι Λόγοι", label: "Διάφοροι Λόγοι" },
        { value: "Πάθηση Αναπαραγ", label: "Πάθηση Αναπαραγ" },
        { value: "Πάθηση Μαστού", label: "Πάθηση Μαστού" },
        { value: "Πάθηση", label: "Πάθηση" },
        { value: "Αποβολή", label: "Αποβολή" },
        { value: "Άγνωστη Αιτία", label: "Άγνωστη Αιτία" },
    ],
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => {
        return value.length === 0 || value.includes(row[id]);
    },
    Cell: TypographyCell,
}

export const cullingCodeHeaderNoFilter = {
    Header: <Typography id="culling_code_header" variant="h8">{"Αιτία απομάκρυνσης"}</Typography>,
    accessor: "cullingCode",
    id: "cullingCode",
    filterable: false,
    useDropdownFilter: true,
    filterOptions: [
        { value: "Σφαγή", label: "Σφαγή" },
        { value: "Πώληση Αναπαραγ", label: "Πώληση Αναπαραγ" },
        { value: "Μεγάλη Ηλικία", label: "Μεγάλη Ηλικία" },
        { value: "Θάνατος", label: "Θάνατος" },
        { value: "Διάφοροι Λόγοι", label: "Διάφοροι Λόγοι" },
        { value: "Πάθηση Αναπαραγ", label: "Πάθηση Αναπαραγ" },
        { value: "Πάθηση Μαστού", label: "Πάθηση Μαστού" },
        { value: "Πάθηση", label: "Πάθηση" },
        { value: "Αποβολή", label: "Αποβολή" },
        { value: "Άγνωστη Αιτία", label: "Άγνωστη Αιτία" },
    ],
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => {
        return value.length === 0 || value.includes(row[id]);
    },
    Cell: TypographyCell,
}

export const cullingDateHeader = {
    Header: <Typography id="culling_date_header" variant="h8">{"Ημ/νια Απομάκρυνσης"}</Typography>,
    accessor: "cullingDate",
    id: "cullingDate",
    filterable: true,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const cullingDateHeaderNoFilter = {
    Header: <Typography id="culling_date_header" variant="h8">{"Ημ/νια Απομάκρυνσης"}</Typography>,
    accessor: "cullingDate",
    id: "cullingDate",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const matingTypeHeader = {
    Header: <Typography id="type_header" variant="h8">{"Είδος Σύζευξης"}</Typography>,
    accessor: "type",
    id: "type",
    filterable: true,
    maxWidth: 150,
    minWidth: 150,
    useDropdownFilter: true,
    filterOptions: [
        { value: "Ομαδική", label: "Ομαδική" },
        { value: "Ατομική", label: "Ατομική" },
        { value: "Τεχνητή", label: "Τεχνητή" },
    ],
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => {
        return value.length === 0 || value.includes(row[id]);
    },
    Cell: TypographyCell,
}

export const matingFatherHeader = (handleAnimalCodeClick) => {
    return {
        Header: <Typography id="sireRegistrationCode_header" variant="h8">{"Πατέρας"}</Typography>,
        accessor: "sireRegistrationCode",
        id: "sireRegistrationCode",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleAnimalCodeClick} />
        ),
    }
}

export const reportTitleHeader = (handleReportClick) => {
    return {
        Header: <Typography id="report_title_header" variant="h8">{"Τίτλος"}</Typography>,
        accessor: "title",
        id: "title",
        filterable: true,
        maxWidth: 500,
        minWidth: 500,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleReportClick} />
        ),
    }
}

export const reportDateHeader = {
    Header: <Typography id="report_date_header" variant="h8">{"Ημ/νία Προσθήκης"}</Typography>,
    accessor: "createdAt",
    id: "createdAt",
    filterable: false,
    maxWidth: 650,
    minWidth: 650,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const matingMotherHeader = (handleAnimalCodeClick) => {
    return {
        Header: <Typography id="damRegistrationCode_header" variant="h8">{"Μητέρα"}</Typography>,
        accessor: "damRegistrationCode",
        id: "damRegistrationCode",
        filterable: true,
        maxWidth: 250,
        minWidth: 200,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isExactMatch(row[id], value),
        Cell: ({ value }) => (
            <ButtonCell value={value} onClick={handleAnimalCodeClick} />
        ),
    }
}

export const matingDateHeader = {
    Header: <Typography id="mating_date_header" variant="h8">{"Ημ/νία Σύζευξης"}</Typography>,
    accessor: "matDate",
    id: "matDate",
    filterable: true,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const sireInDateHeader = {
    Header: <Typography id="sire_in_date_header" variant="h8">{"Ημ/νία Εισόδου Κριού"}</Typography>,
    accessor: "enterDate",
    id: "enterDate",
    filterable: true,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const sireOutDateHeader = {
    Header: <Typography id="sire_out_date_header" variant="h8">{"Ημ/νία Εξόδου Κριού"}</Typography>,
    accessor: "matingDate2",
    id: "matingDate2",
    filterable: true,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const femaleAnimalHeader = {
    Header: <Typography id="registration_code_header" variant="h8">{"Κωδικός προβατίνας"}</Typography>,
    accessor: "registrationCode",
    id: "registrationCode",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}


export const relationshipHeader = {
    Header: <Typography id="relationship_header" variant="h8">{"Δείκτης συγγένειας"}</Typography>,
    accessor: "relationship",
    id: "relationship",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const weightDateHeader = (handelWeightDateHeaderClick) => {
    return {
        Header: <Typography id="weight_date_header" variant="h8">{"Ημερομηνία Ζύγισης"}</Typography>,
        accessor: "date",
        id: "date",
        filterable: true,
        maxWidth: 600,
        minWidth: 230,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <DateButtonCell value={value} onClick={handelWeightDateHeaderClick} />
        ),
    }
}

export const censusDateHeader = (handelCensusDateHeaderClick) => {
    return {
        Header: <Typography id="census_date_header" variant="h8">{"Ημ/νία Απογραφής"}</Typography>,
        accessor: "censusDate",
        id: "censusDate",
        filterable: true,
        maxWidth: 600,
        minWidth: 230,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value }) => (
            <DateButtonCell value={value} onClick={handelCensusDateHeaderClick} />
        ),
    }
}

export const deleteButtonCell = (handleDelete) => {
    return {
        Header: <Typography variant="h8">{""}</Typography>,
        accessor: "",
        filterable: false,
        sortable: false,
        maxWidth: 200,
        minWidth: 180,
        Cell: ({ value }) => (
            <ToggleButtonGroup exclusive size="small" aria-label="actions">
                <ToggleButton
                    value="delete"
                    title="Διαγραφή Πρόσκλησης"
                    aria-label="delete"
                    sx={{ borderColor: "primary.main" }}
                    onClick={() => handleDelete(value)}
                >
                    <DeleteIcon color="primary.main" />
                </ToggleButton>
            </ToggleButtonGroup>
        ),
    }
}

export const femaleDeadLambsHeader = {
    Header: <Typography id="female_dead_lambs_header" variant="h8">{"Θηλυκά Νεκρά"}</Typography>,
    accessor: "femaleDeadLambs",
    id: "femaleDeadLambs",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const maleDeadLambsHeader = {
    Header: <Typography id="male_dead_lambs_header" variant="h8">{"Αρσενικά Νεκρά"}</Typography>,
    accessor: "maleDeadLambs",
    id: "maleDeadLambs",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const femaleAliveLambsHeader = {
    Header: <Typography id="female_alive_lambs_header" variant="h8">{"Θηλυκά Ζωντανά"}</Typography>,
    accessor: "femaleAliveLambs",
    id: "femaleAliveLambs",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const maleAliveLambsHeader = {
    Header: <Typography id="male_alive_lambs_header" variant="h8">{"Αρσενικά Ζωντανά"}</Typography>,
    accessor: "maleAliveLambs",
    id: "maleAliveLambs",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const populationLambsHeader = {
    Header: <Typography id="lambs_header" variant="h8">{"Αμνοί"}</Typography>,
    accessor: "aliveLambs",
    id: "aliveLambs",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const animalsLambedInPeriodHeader = {
    Header: <Typography id="lambed_in_period_header" variant="h8">{"Σε γαλακ/γή"}</Typography>,
    accessor: "animalsLambedInPeriod",
    id: "animalsLambedInPeriod",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const animalsNotLambedInPeriodHeader = {
    Header: <Typography id="not_lambed_in_period_header" variant="h8">{"Στέρφα"}</Typography>,
    accessor: "animalsNotLambedInPeriod",
    id: "animalsNotLambedInPeriod",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const animalsNeverLambedHeader = {
    Header: <Typography id="never_lambed_header" variant="h8">{"Ζυγούρια"}</Typography>,
    accessor: "animalsNeverLambed",
    id: "animalsNeverLambed",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const populationMaleAliveHeader = {
    Header: <Typography id="male_alive_header" variant="h8">{"Αρσενικά"}</Typography>,
    accessor: "maleAlive",
    id: "maleAlive",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const populationFemaleAliveHeader = {
    Header: <Typography id="female_alive_header" variant="h8">{"Θηλυκά"}</Typography>,
    accessor: "female",
    id: "female",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const populationLambedAtLeastOnceHeader = {
    Header: <Typography id="lambed_once_header" variant="h8">{"Προβατίνες"}</Typography>,
    accessor: "animalsLambedAtLeastOnce",
    id: "animalsLambedAtLeastOnce",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const registeredInFlockHeader = {
    Header: <Typography id="registered_in_flock_header" variant="h8">{"Καταγεγραμμένα"}</Typography>,
    accessor: "registeredInFlock",
    id: "registeredInFlock",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const aliveAnimalsHeader = {
    Header: <Typography id="alive_animals_header" variant="h8">{"Δυναμικό"}</Typography>,
    accessor: "aliveAnimals",
    id: "aliveAnimals",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
};

export const weightHeader = {
    Header: <Typography id="weight_header" variant="h8">{"Βάρος"}</Typography>,
    accessor: "weight",
    id: "weight",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambingDateHeader = {
    Header: <Typography id="lambing_date_header" variant="h8">{"Ημ/νία Τοκετού"}</Typography>,
    accessor: "lambingDate",
    id: "lambingDate",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    useDatePickerFilter: true,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: dateRangeFilterMethod,
    Cell: DateCell,
}

export const maleAnimalHeader = {
    Header: <Typography id="registration_code_header" variant="h8">{"Κωδικός Κριού"}</Typography>,
    accessor: "registrationCode",
    id: "registrationCode",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambAnimalCodeHeader = {
    Header: <Typography id="lamb_slug_header" variant="h8">{"Κωδικός Αμνού"}</Typography>,
    accessor: "lambSlug",
    id: "lambSlug",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambSlugHeaderNoFilterable = {
    Header: <Typography id="lamb_slug_header" variant="h8">{"Κωδικός Αμνού"}</Typography>,
    accessor: "lambSlug",
    id: "lambSlug",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sireCodeHeaderNonClick = {
    Header: <Typography id="sire_code_header" variant="h8">{"Κωδικός Πατέρα"}</Typography>,
    accessor: "sireCode",
    id: "sireCode",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const damCodeHeaderNonClick = {
    Header: <Typography id="dam_code_header" variant="h8">{"Κωδικός Μητέρας"}</Typography>,
    accessor: "damCode",
    id: "damCode",
    filterable: true,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const orderNumberHeader = {
    Header: <Typography id="order_number_header" variant="h8">{"Αριθμός Παραγγελίας"}</Typography>,
    accessor: "orderNumber",
    id: "orderNumber",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const orderSellerHeader = {
    Header: <Typography id="order_seller_header" variant="h8">{"Εκτροφή"}</Typography>,
    accessor: "saleOwner",
    id: "saleOwner",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const orderBuyerHeader = {
    Header: <Typography id="order_buyer_header" variant="h8">{"Ονοματεπώνυμο αγοραστή"}</Typography>,
    accessor: "buyerFullName",
    id: "buyerFullName",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const orderCityHeader = {
    Header: <Typography id="order_city_header" variant="h8">{"Διεύθυνση"}</Typography>,
    accessor: "city",
    id: "city",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const orderDateHeader = {
    Header: <Typography id="order_date_header" variant="h8">{"Ημερομηνία Παραγγελίας"}</Typography>,
    accessor: "orderDate",
    id: "orderDate",
    filterable: false,
    maxWidth: 450,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: DateCell,
}

export const executionDateHeader = {
    Header: <Typography id="execution_date_header" variant="h8">{"Ημερομηνία Αποστολής"}</Typography>,
    accessor: "executionDate",
    id: "executionDate",
    filterable: false,
    maxWidth: 450,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: DateCell,
}

export const animalTypeHeader = {
    Header: <Typography id="animal_type_header" variant="h8">{"Τύπος Ζώου"}</Typography>,
    accessor: "type",
    id: "type",
    filterable: true,
    maxWidth: 400,
    minWidth: 230,
    useDropdownFilter: true,
    filterOptions: [
        { value: "Κριός", label: "Κριός" },
        { value: "Προβατίνα", label: "Προβατίνα" },
        { value: "Αμνός", label: "Αμνός" },
    ],
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => {
        return value.length === 0 || value.includes(row[id]);
    },
    Cell: TypographyCell,
}

export const animalValueHeader = {
    Header: <Typography id="animal_value_header" variant="h8">{"Tιμή (€)"}</Typography>,
    accessor: "value",
    id: "value",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const birthWeightHeader = {
    Header: <Typography id="birth_weight_header" variant="h8">{"Βάρος Γέννησης (kg)"}</Typography>,
    accessor: "birthWeight",
    id: "birthWeight",
    filterable: false,
    maxWidth: 300,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const weaningWeightHeader = {
    Header: <Typography id="weaning_weight_header" variant="h8">{"Βάρος Απογαλακτισμού (kg)"}</Typography>,
    accessor: "weaningnWeight",
    id: "weaningnWeight",
    filterable: false,
    maxWidth: 150,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambStatusHeader = {
    Header: <Typography id="lamb_status_header" variant="h8">{"Κατάληξη Αμνού"}</Typography>,
    accessor: "status",
    id: "status",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambStatusHeaderClickable = (handleStatusClick) => {
    return {
        Header: <Typography id="lamb_status_header" variant="h8">{"Κατάληξη Αμνού"}</Typography>,
        accessor: "status",
        id: "status",
        filterable: false,
        maxWidth: 600,
        minWidth: 230,
        sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
        filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
        Cell: ({ value, row }) => {
            const lamb = row._original;
            const isUneditableEndedLamb = lamb.isEndedLamb && value !== "Άγνωστη";

            if (value === "Εγγραφή στην εκτροφή" || isUneditableEndedLamb) {
                return <TypographyCell value={value} />;
            }
            return <ButtonCell value={value} onClick={() => handleStatusClick(lamb)} />;
        },
    }
}

export const registrationCodeHeaderNoClick = {
    Header: <Typography id="flock_code_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κωδικός Γενεαλογικού Βιβλίου"}</Typography>,
    accessor: "registrationCode",
    id: "registrationCode",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sexHeaderNoFilter = {
    Header: <Typography id="sex_header" variant="h8">{"Φύλο"}</Typography>,
    accessor: "sex",
    id: "sex",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const ownerHeaderNoClick = {
    Header: <Typography id="owner_header" variant="h8">{"Εκτροφή"}</Typography>,
    accessor: "owner",
    id: "owner",
    filterable: false,
    maxWidth: 600,
    minWidth: 230,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const damCodeHeaderNoClick = {
    Header: <Typography id="dam_code_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κωδ. Γενεαλογικού Βιβλίου Μητέρας"}</Typography>,
    accessor: "damCode",
    id: "damCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    // sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    // filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sireCodeHeaderNoClick = {
    Header: <Typography id="sire_code_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κωδ. Γενεαλογικού Βιβλίου Πατέρα"}</Typography>,
    accessor: "sireCode",
    id: "sireCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const abortionCodeHeader = {
    Header: <Typography id="abortion_code_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κατάσταση Τοκετού"}</Typography>,
    accessor: "abortionCode",
    id: "abortionCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const prolificacyHeader = {
    Header: <Typography id="prolificacy_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Πολυδυμία"}</Typography>,
    accessor: "prolificacy",
    id: "prolificacy",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    // sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lactationNumberHeader = {
    Header: <Typography id="lactation_number_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Α/Α Γαλακτικής Περιόδου"}</Typography>,
    accessor: "lactationNumber",
    id: "lactationNumber",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    // sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    // filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const lambsHeader = {
    Header: <Typography id="lactation_number_header" variant="h8" sx={{
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Αμνοί"}</Typography>,
    accessor: "lambs",
    id: "lambs",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    // sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    // filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: ArrayTextCell,
}

export const maleAliveHeader = {
    Header: <Typography id="male_alive_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Ζωντανά Αρσενικά"}</Typography>,
    accessor: "maleAlive",
    id: "maleAlive",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const femaleAliveHeader = {
    Header: <Typography id="female_alive_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Ζωντανά Θηλυκά"}</Typography>,
    accessor: "femaleAlive",
    id: "femaleAlive",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const maleDeadHeader = {
    Header: <Typography id="male_dead_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Νεκρά Αρσενικά"}</Typography>,
    accessor: "maleDead",
    id: "maleDead",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const femaleDeadHeader = {
    Header: <Typography id="female_dead_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Νεκρά Θηλυκά"}</Typography>,
    accessor: "femaleDead",
    id: "femaleDead",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sampleNumberHeader = {
    Header: <Typography id="sample_number_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Αριθμός Δείγματος"}</Typography>,
    accessor: "sampleCode",
    id: "sampleCode",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const firstResultHeader = {
    Header: <Typography id="first_result_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Πρώτο Αποτέλεσμα"}</Typography>,
    accessor: "result1",
    id: "result1",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const secondResultHeader = {
    Header: <Typography id="second_result_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Δεύτερο Αποτέλεσμα"}</Typography>,
    accessor: "result2",
    id: "result2",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const sampleDateHeader = {
    Header: <Typography id="sample_date_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Ημερομηνία Δειγματοληψίας"}</Typography>,
    accessor: "sampleDate",
    id: "sampleDate",
    filterable: false,
    maxWidth: 450,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: DateCell,
}

export const resultDateHeader = {
    Header: <Typography id="sample_date_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Ημερομηνία Αποτελεσμάτων"}</Typography>,
    accessor: "resultDate",
    id: "resultDate",
    filterable: false,
    maxWidth: 450,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: DateCell,
}

export const authenticityHeader = {
    Header: <Typography id="authenticity_header" variant="h8" sx={{
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflow: "hidden",
        textAlign: "center"
    }}>{"Κατηγορία Αυθεντικοποίησης (NSP)"}</Typography>,
    accessor: "authenticity",
    id: "authenticity",
    filterable: false,
    maxWidth: 250,
    minWidth: 200,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

// Registration Logs Headers
export const registrationLogTimestampHeader = {
    Header: <Typography id="log_timestamp_header" variant="h8">{"Ημερομηνία & Ώρα"}</Typography>,
    accessor: "timestamp",
    id: "timestamp",
    filterable: false,
    maxWidth: 200,
    minWidth: 170,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const registrationLogUserNameHeader = {
    Header: <Typography id="log_user_name_header" variant="h8">{"Χρήστης"}</Typography>,
    accessor: "userName",
    id: "userName",
    filterable: true,
    maxWidth: 180,
    minWidth: 150,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const registrationLogUserEmailHeader = {
    Header: <Typography id="log_user_email_header" variant="h8">{"Email Χρήστη"}</Typography>,
    accessor: "userEmail",
    id: "userEmail",
    filterable: false,
    maxWidth: 200,
    minWidth: 180,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const registrationLogOwnerCodeHeader = {
    Header: <Typography id="log_owner_code_header" variant="h8">{"Κωδ. Εκτροφής"}</Typography>,
    accessor: "ownerCode",
    id: "ownerCode",
    filterable: false,
    maxWidth: 150,
    minWidth: 120,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const registrationLogOwnerNameHeader = {
    Header: <Typography id="log_owner_name_header" variant="h8">{"Όνομα Ιδιοκτήτη"}</Typography>,
    accessor: "ownerName",
    id: "ownerName",
    filterable: true,
    maxWidth: 200,
    minWidth: 180,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}

export const registrationLogAnimalCodeHeader = {
    Header: <Typography id="log_animal_code_header" variant="h8">{"Κωδικός Ζώου"}</Typography>,
    accessor: "animalCode",
    id: "animalCode",
    filterable: true,
    maxWidth: 160,
    minWidth: 140,
    sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
    filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
    Cell: TypographyCell,
}
